import * as THREE from 'three';
import { FontLoader } from 'three/src/loaders/FontLoader.js';

export const IfcGeometryMixin = {
    methods: {
        createUnstagedGeometryMesh(unstaged_geometry, object, material, name, render_order) {
          let mesh = new THREE.Mesh(unstaged_geometry, material);
          mesh.name = `${name}_unstaged_${object.id}`;
          mesh.unstaged = true;
          mesh.takting_id = `${object.id}`;
          mesh.position.x = object.geometry.offset[0];
          mesh.position.y = object.geometry.offset[1];
          mesh.position.z = object.geometry.offset[2];
          if (render_order) {
            mesh.renderOrder = render_order;
          }
          return mesh;
        },
        createUnstagedGeometry(geometry) {
          return this[`createMesh${geometry.type}`](geometry);
        },
        // renderLine({target, geometry}) {
        //     if (geometry.points > 1) {
                
        //     }
        // }
        moveUnstagedGeometryPoint(unstaged_mesh, geometry, point_index, raycasted_point) {
          this[`movePoint${geometry.type}`](unstaged_mesh, geometry, point_index, raycasted_point);
        },
        deleteUnstagedGeometryPoint(unstaged_mesh, geometry, point_index) {
          geometry.points_x.splice(point_index, 1);
          geometry.points_y.splice(point_index, 1);
          let geom = this[`createMesh${geometry.type}`](geometry);
          if (unstaged_mesh.geometry) {
            unstaged_mesh.geometry.dispose()
            unstaged_mesh.geometry = geom;
          }
        },
        scaleUnstagedGeometry(unstaged_mesh, geometry, scale_factor) {
          for (let i = 0; i < geometry.points_x.length; i++) {
            geometry.points_x[i] = geometry.points_x[i] * scale_factor;
            geometry.points_y[i] = geometry.points_y[i] * scale_factor;
            if (geometry.points_z) {
              geometry.points_z[i] = geometry.points_z[i] * scale_factor;
            }
          }
          let geom = this[`createMesh${geometry.type}`](geometry);
          if (unstaged_mesh.geometry) {
            unstaged_mesh.geometry.dispose()
            unstaged_mesh.geometry = geom;
          }
        },
        addUnstagedGeometryPoint(unstaged_mesh, geometry, point_index, point) {
          geometry.points_x.splice(point_index+1, 0, point.x+0.001);
          geometry.points_y.splice(point_index+1, 0, point.y+0.001);
          if (geometry.points_z) {
            geometry.points_z.splice(point_index+1, 0, point.z);
          }
          let geom = this[`createMesh${geometry.type}`](geometry);
          if (unstaged_mesh.geometry) {
            unstaged_mesh.geometry.dispose()
            unstaged_mesh.geometry = geom;
          } else {
            this.edit_unstaged_geometry = geom;
            this.edit_geom_mesh = this.createUnstagedGeometryMesh(this.edit_unstaged_geometry, this.edit_geometry_object, this.highlight_material, 'edit');
            this.all_groups.add(this.edit_geom_mesh);
          }
        },
        createTextMesh(text) {
          return new Promise(resolve => {
            const loader = new FontLoader();
            loader.load( '/fonts/helvetiker_regular.typeface.json', function ( font ) {
            const color = 0x006699;
            const matLite = new THREE.MeshBasicMaterial( {
              color: color,
              transparent: true,
              opacity: 0.6,
              side: THREE.DoubleSide
            } );
  
            // const message = '   Three.js\nSimple text.';
            const message = text;
  
            const shapes = font.generateShapes( message, 10 );
  
            const geometry = new THREE.ShapeGeometry( shapes );
  
            geometry.computeBoundingBox();
  
            geometry.rotateX(- Math.PI / 2);

            const xMid = - 0.5 * ( geometry.boundingBox.max.x - geometry.boundingBox.min.x );
            const zMid = 0.5 * ( geometry.boundingBox.max.z - geometry.boundingBox.min.z );
  
            geometry.translate( xMid, 0, zMid );
  
            const mesh = new THREE.Mesh( geometry, matLite );
            resolve(mesh);
  
            });
          })
        },

        // GEOMETRY TXYPES
        createMeshShape(geometry) {
          if (geometry.points_x.length > 0) {
            let points = [];
            for (let i = 0; i < geometry.points_x.length; i++) {
                points.push( new THREE.Vector2( geometry.points_x[i], geometry.points_y[i] ) );
              }
              let shape = new THREE.Shape( points );
            
              let geom = new THREE.ShapeGeometry( shape );
            //   this.setGeometryTaktingId(geom, id);
              // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
              geom.rotateX(- Math.PI / 2);

              return geom;
          } else {
            return false;
          }
        },
        movePointShape(unstaged_mesh, geometry, point_index, raycasted_point) {
          let shape = unstaged_mesh.geometry.parameters.shapes;
          if (point_index !== geometry.points_x.length-1) {
            shape.curves[point_index].v1.x = raycasted_point.x;
            shape.curves[point_index].v1.y = raycasted_point.y;
          }
          if (point_index > 0) {
            shape.curves[point_index - 1].v2.x = raycasted_point.x;
            shape.curves[point_index - 1].v2.y = raycasted_point.y;
          }
          let geom = new THREE.ShapeGeometry( shape );
          // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
          geom.rotateX(- Math.PI / 2);
          unstaged_mesh.geometry.dispose()
          unstaged_mesh.geometry = geom;
          // set point values
          geometry.points_x[point_index] = raycasted_point.x;
          geometry.points_y[point_index] = raycasted_point.y;
        },
        createMeshExtrudedShape(geometry) {
          if (geometry.points_x.length > 0) {
            let points = [];
            for (let i = 0; i < geometry.points_x.length; i++) {
                points.push( new THREE.Vector2( geometry.points_x[i], geometry.points_y[i] ) );
              }
              let shape = new THREE.Shape( points );
            
              let geom = new THREE.ExtrudeGeometry(shape, { depth: geometry.extrude_value, steps: 1, bevelEnabled: false});
            //   this.setGeometryTaktingId(geom, id);
              // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
              geom.rotateX(- Math.PI / 2);

              return geom;
          } else {
            return false;
          }
        },
        movePointExtrudedShape(unstaged_mesh, geometry, point_index, raycasted_point) {
          let shape = unstaged_mesh.geometry.parameters.shapes;
          if (point_index !== geometry.points_x.length-1) {
            shape.curves[point_index].v1.x = raycasted_point.x;
            shape.curves[point_index].v1.y = raycasted_point.y;
          }
          if (point_index > 0) {
            shape.curves[point_index - 1].v2.x = raycasted_point.x;
            shape.curves[point_index - 1].v2.y = raycasted_point.y;
          }
          let geom = new THREE.ExtrudeGeometry(shape, { depth: geometry.extrude_value, steps: 1, bevelEnabled: false});
          // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
          geom.rotateX(- Math.PI / 2);
          unstaged_mesh.geometry.dispose()
          unstaged_mesh.geometry = geom;
          // set point values
          geometry.points_x[point_index] = raycasted_point.x;
          geometry.points_y[point_index] = raycasted_point.y;
        },
        createMeshExtrudedShapeLateral(geometry) {
            if (geometry.points_x.length > 0) {
              let points = [];
              for (let i = 0; i < geometry.points_x.length; i++) {
                  points.push( new THREE.Vector2( geometry.points_x[i], geometry.points_y[i] ) );
                }
                let shape = new THREE.Shape( points );
              
                let geom = new THREE.ExtrudeGeometry(shape, { depth: geometry.extrude_value, steps: 1, bevelEnabled: false});
              //   this.setGeometryTaktingId(geom, id);
                // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
                geom.rotateX(- Math.PI / 2);
  
                //lateral
                let start = geom.groups[1].start * 3;
                let count = geom.groups[1].count * 3;
              
                let lateral_geom = new THREE.BufferGeometry();
                let vertices = new Float32Array( geom.attributes.position.array.slice(start, start+count) );
                lateral_geom.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ));
              
                let normals = new Float32Array( geom.attributes.normal.array.slice(start, start+count) );
                lateral_geom.setAttribute( 'normal', new THREE.BufferAttribute( normals, 3 ));
  
                lateral_geom.shape_cache = shape;
  
                return lateral_geom;
            } else {
              return false;
            }
        },
        movePointExtrudedShapeLateral(unstaged_mesh, geometry, point_index, raycasted_point) {
          let shape = unstaged_mesh.geometry.shape_cache;
          if (point_index !== geometry.points_x.length-1) {
            shape.curves[point_index].v1.x = raycasted_point.x;
            shape.curves[point_index].v1.y = raycasted_point.y;
          }
          if (point_index > 0) {
            shape.curves[point_index - 1].v2.x = raycasted_point.x;
            shape.curves[point_index - 1].v2.y = raycasted_point.y;
          }
          let geom = new THREE.ExtrudeGeometry(shape, { depth: geometry.extrude_value, steps: 1, bevelEnabled: false});
          // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
          geom.rotateX(- Math.PI / 2);

          //lateral
          let start = geom.groups[1].start * 3;
          let count = geom.groups[1].count * 3;
        
          let lateral_geom = new THREE.BufferGeometry();
          let vertices = new Float32Array( geom.attributes.position.array.slice(start, start+count) );
          lateral_geom.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ));
        
          let normals = new Float32Array( geom.attributes.normal.array.slice(start, start+count) );
          lateral_geom.setAttribute( 'normal', new THREE.BufferAttribute( normals, 3 ));

          lateral_geom.shape_cache = shape;

          unstaged_mesh.geometry.dispose()
          unstaged_mesh.geometry = lateral_geom;
          // set point values
          geometry.points_x[point_index] = raycasted_point.x;
          geometry.points_y[point_index] = raycasted_point.y;
        },
        createMeshTube(geometry) {
          if (geometry.points_x.length > 1) {
            let points = [];
            for (let i = 0; i < geometry.points_x.length; i++) {
              points.push( new THREE.Vector3( geometry.points_x[i], geometry.points_y[i], geometry.points_z[i] ) );
            }
            let curves = [];
            for (let i = 1; i < points.length; i++) {
              curves.push(new THREE.LineCurve3(points[i-1], points[i]));
            }
            let path = new THREE.CurvePath();
            for (let i = 0; i < curves.length; i++) {
              path.add(curves[i]);
            }
     
            let geom = new THREE.TubeGeometry( path, 64, 0.05, 8, false  );
            // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
            geom.rotateX(- Math.PI / 2);
            return geom;
          } else {
            return false;
          }
        },
        movePointTube(unstaged_mesh, geometry, point_index, raycasted_point) {
          if (geometry.points_x.length > 1) {
            let path = unstaged_mesh.geometry.parameters.path;
            if (point_index !== geometry.points_x.length-1) {
              path.curves[point_index].v1.x = raycasted_point.x;
              path.curves[point_index].v1.y = raycasted_point.y;
              path.curves[point_index].v1.z = raycasted_point.z;
              // path.curves[point_index].updateArcLengths();
            }
            if (point_index > 0) {
              path.curves[point_index - 1].v2.x = raycasted_point.x;
              path.curves[point_index - 1].v2.y = raycasted_point.y;
              path.curves[point_index - 1].v2.z = raycasted_point.z;
              // path.curves[point_index - 1].updateArcLengths();
            }
            // path.updateArcLengths();
            let geom = new THREE.TubeGeometry( path, 64, 0.05, 8, false  );
            // geom.translate(geometry.offset[0], geometry.offset[1], geometry.offset[2]);
            geom.rotateX(- Math.PI / 2);
            unstaged_mesh.geometry.dispose()
            unstaged_mesh.geometry = geom;
            // set path length
            // geometry.path_length = path.getCurveLengths()[0];
            // console.log(geom.parameters.path);
            // geom.parameters.path.needsUpdate = true;
            // geom.parameters.path.curves[0].needsUpdate = true;
            // let el = document.getElementById('testblatest')
            // el.innerHTML = path.getCurveLengths()[0].toFixed(2);
          }
          // set point values
          geometry.points_x[point_index] = raycasted_point.x;
          geometry.points_y[point_index] = raycasted_point.y;
          geometry.points_z[point_index] = raycasted_point.z;
        },

        // not used
        setGeometryTaktingId(geom, id) {
            let size = geom.attributes.position.count;
            let taktingIdAttribute = new Array(size).fill(id);
            let buffer_attr = new THREE.BufferAttribute(new Uint32Array(taktingIdAttribute), 1);

            geom.setAttribute('takting_id', buffer_attr);
        }
    }
}